export default __webpack_public_path__ + "static/media/Tailwind Black.b437f60f.woff2";